import React, { useState, useRef, useEffect, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import Select from 'react-select';
import { notification, Tooltip } from 'antd';

import {
  isTicketOpen,
  setDrawerWidth,
  isChatSettingsOpen,
  addChatRoom,
  updateChatRoomPreferences,
  addUserToChat,
  removeUserFromChat,
  getChatRoomFiles,
  exitFromChatRoom,
} from '../../../actions';

import { setRoomId } from '../../../actions/roomAction';

import {
  RESET_COUNTER,
  UPDATE_CURRENT_RECEIVER,
} from '../../../actions/types/chat.types';

import { updateChatRoomMessagesReadBy } from '../../../actions/chatRoomAction';

import {
  clearMessagesState,
  updateQueryState,
} from '../../../actions/messageAction';

import Icon from '../atoms/global/Icon';
import ConfirmationModal from '../molecules/modals/ConfirmationModal';
import RoomPicture from '../molecules/global/RoomPicture';

import AssigneeOptionLabel from '../atoms/ticket-drawer/AssigneeOptionLabel';
import { getDateTextLongFormat } from '../../../js/functions';
import { MemberActionsMenu } from '../molecules/right-click-menu/MemberActionsMenu';
import {
  isMemberDrawerOpen,
  isUserDrawerOpen,
} from '../../../actions/toggleAction';
import UserAvatar from '../atoms/ticket-drawer/UserAvatar';
import { FormattedMessage, useIntl } from 'react-intl';

const UserChatPanel = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const param = useParams();

  const {
    allUsers,
    senderId,
    chats,
    me,
    currentWorkspace,
  } = props;

  const ticketDrawerRef = useRef(null);

  const chat =
    chats &&
    chats.find((chat) =>
      senderId ? senderId == chat?._id : chat._id === param.chatId
    );
  const user = allUsers?.find((user) => user?._id == senderId);

  let membersNotInChat = [];
  const [chatMembers, setChatMembers] = useState([]);

  if (chatMembers) {
    membersNotInChat = currentWorkspace?.members.filter(
      (wMember) => !chatMembers.some((member) => member._id === wMember._id)
    );
  }

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  const [showAddMember, setShowAddMember] = useState(false);
  const [assigneeValue, setAssigneeValue] = useState([]);
  const [openMenuMemberId, setOpenMenuMemberId] = useState(null);
  const menuRefs = useRef({});

  const toggleMenu = (memberId) => {
    setOpenMenuMemberId((prev) => (prev === memberId ? null : memberId));
  };

  useEffect(() => {
    if (!user && !chat) {
      dispatch(isChatSettingsOpen(false));
    }
    if (chat?._id) {
      dispatch(getChatRoomFiles(chat?._id));
      setChatMembers(chat?.members);
    }
  }, [user, chat]);

  const updateChatPreferences = () => {
    dispatch(updateChatRoomPreferences({ notifications: !chat?.notifications, chatId: chat?._id }));
  };

  const openChat = async (userId) => {
    const existingChat = chats?.find(
      (chat) => chat?.roomType === 'direct' && chat?.members?.find((mem) => mem?._id === userId)
    );
    if (existingChat) {
      dispatch(updateQueryState(1));
      dispatch(clearMessagesState());
      dispatch(setRoomId(existingChat?._id));
      dispatch({ type: RESET_COUNTER, payload: existingChat?._id });
      navigate(`/chat/${existingChat?._id}`, { replace: true });
      dispatch({ type: UPDATE_CURRENT_RECEIVER, payload: existingChat?.roomName });
      dispatch(updateChatRoomMessagesReadBy(existingChat?._id, 'ChatsNavBar1'));
    } else {
      dispatch(addChatRoom({ members: [userId], roomName: null, workspaceId: currentWorkspace?._id }));
    }
    dispatch(isChatSettingsOpen(false));
  };

  const isDirectChat = chat?.roomType == 'direct';
  const directMessageRecipient = isDirectChat && chat?.members?.find((member) => member._id !== user?._id);
  const isMe = me?._id == user?._id;

  const header = user
    ? `${intl.formatMessage({ id: 'USER_INFO', defaultMessage: 'User Info' })}${isMe ? ' (Me)' : ''}`
    : `${intl.formatMessage({ id: `${chat?.roomType}_CHAT_TYPE`.toUpperCase(), defaultMessage: chat?.roomType })} ${intl.formatMessage({ id: 'CHAT_SETTINGS', defaultMessage: 'Chat - Settings' })}`;

  const cardImage = user?.avi || chat?.roomAvi || directMessageRecipient?.avi;

  const cardImageRenderer = useCallback(() => {
    if (user?.avi) return <UserAvatar classNames="rounded-full size-[88px] object-cover" fullName={user?.fullName} userId={user?._id} src={user?.avi} />;
    if (directMessageRecipient?.avi) return <UserAvatar classNames="rounded-full size-[88px] object-cover" fullName={directMessageRecipient?.fullName} userId={directMessageRecipient?._id} src={directMessageRecipient?.avi} />;
    return <img src={cardImage} className="rounded-full size-[88px] object-cover" />;
  }, [cardImage, directMessageRecipient, user]);

  const displayCount = showAddMember ? membersNotInChat?.length : chatMembers?.length;
  const displayLabel = showAddMember
    ? intl.formatMessage({ id: 'MEMBERS_NOT_IN_CHAT', defaultMessage: 'Members not in chat' })
    : intl.formatMessage({ id: 'MEMBERS', defaultMessage: 'Members' });

  return (
    <>
      <ConfirmationModal
        title={`${intl.formatMessage({ id: 'DELETE_TASK', defaultMessage: 'Delete Task' })}?`}
        description={intl.formatMessage({ id: 'DELETE_TASK_CONFIRMATION', defaultMessage: 'Are you sure you want to delete this task?' })}
        isModalOpen={isDeleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        onYesClick={() => {}}
      />
      <ConfirmationModal
        title={`${intl.formatMessage({ id: 'EXIT_CHAT', defaultMessage: 'Exit Chat' })}?`}
        description={intl.formatMessage({ id: 'EXIT_CHAT_CONFIRMATION', defaultMessage: 'Are you sure you want to exit this chat?' })}
        isModalOpen={isExitModalOpen}
        onCancel={() => setIsExitModalOpen(false)}
        onYesClick={() => {
          setIsExitModalOpen(false);
          dispatch(exitFromChatRoom({ chatId: chat._id, user: me._id }, () => {
            dispatch(isChatSettingsOpen(false));
            navigate('/chat');
          }));
        }}
      />

      <div className="relative flex flex-col h-full" ref={ticketDrawerRef} style={{ background: '#fff' }}>

        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 sticky top-0 z-30" style={{ background: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(99,102,241,0.1)' }}>
          <div className="flex items-center gap-2">
            <button
              onClick={() => { dispatch(isChatSettingsOpen(false)); dispatch(isTicketOpen(true)); }}
              className="flex items-center justify-center size-7 rounded-lg transition-all"
              style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: 'rgba(15,15,25,0.5)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.08)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            <span style={{ fontSize: 14, fontWeight: 700, color: 'rgba(15,15,25,0.85)' }}>{header}</span>
          </div>
          {chat && (
            <Tooltip title={chat?.notifications
              ? intl.formatMessage({ id: 'MUTE', defaultMessage: 'Mute' })
              : intl.formatMessage({ id: 'UNMUTE', defaultMessage: 'Unmute' })
            }>
              <button
                onClick={updateChatPreferences}
                className="flex items-center justify-center size-7 rounded-lg transition-all"
                style={{ border: 'none', background: 'transparent', cursor: 'pointer', opacity: chat?.notifications ? 1 : 0.4 }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.08)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <Icon name="noti-black.svg" height="16px" width="16px" />
              </button>
            </Tooltip>
          )}
        </div>

        <div className="flex flex-col overflow-y-auto flex-1">

          {/* Avatar + name */}
          <div className="flex flex-col items-center pt-8 pb-6 px-6" style={{ borderBottom: '1px solid rgba(99,102,241,0.08)' }}>
            <div className="mb-3" style={{ boxShadow: '0 0 0 3px rgba(99,102,241,0.12)', borderRadius: '50%' }}>
              {chat && chat?.roomAvi ? (
                <RoomPicture room={chat} isRoom={true} />
              ) : cardImage ? (
                cardImageRenderer()
              ) : (
                <div className="rounded-full size-[88px] flex items-center justify-center text-2xl font-bold text-white" style={{ background: 'linear-gradient(135deg, #4f46e5, #7c3aed)' }}>
                  {(chat?.roomName || user?.fullName || '').substring(0, 2).toUpperCase()}
                </div>
              )}
            </div>
            {chat && (
              <>
                <p style={{ fontSize: 17, fontWeight: 700, color: 'rgba(15,15,25,0.85)', textAlign: 'center', margin: '0 0 4px' }}>{chat?.roomName}</p>
                <p style={{ fontSize: 12, color: 'rgba(15,15,25,0.4)', textAlign: 'center' }}>
                  <FormattedMessage id="CREATED" defaultMessage="Created" />{' '}{getDateTextLongFormat(new Date(chat?.createdAt), intl)}
                </p>
              </>
            )}
          </div>

          {chat && (
            <div className="px-4 pt-4 flex flex-col gap-1">

              {/* Add Members action row */}
              <button
                onClick={() => setShowAddMember(!showAddMember)}
                className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-left transition-all"
                style={{ border: '1px solid rgba(99,102,241,0.12)', background: showAddMember ? 'rgba(99,102,241,0.06)' : 'rgba(99,102,241,0.03)', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.08)'}
                onMouseLeave={e => e.currentTarget.style.background = showAddMember ? 'rgba(99,102,241,0.06)' : 'rgba(99,102,241,0.03)'}
              >
                <div className="flex items-center justify-center size-9 rounded-lg flex-shrink-0" style={{ background: 'rgba(99,102,241,0.1)', border: '1px solid rgba(99,102,241,0.2)' }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="rgba(99,102,241,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
                  </svg>
                </div>
                <div className="flex-1 min-w-0">
                  <p style={{ fontSize: 13.5, fontWeight: 600, color: 'rgba(15,15,25,0.8)', margin: 0 }}>
                    {showAddMember
                      ? intl.formatMessage({ id: 'VIEW_MEMBERS', defaultMessage: 'View Members' })
                      : intl.formatMessage({ id: 'ADD_MEMBERS', defaultMessage: 'Add Members' })}
                  </p>
                  <p style={{ fontSize: 11.5, color: 'rgba(15,15,25,0.42)', margin: 0 }}>
                    {showAddMember
                      ? intl.formatMessage({ id: 'VIEW_MEMBERS_DESCRIPTION', defaultMessage: 'View members from your chat' })
                      : intl.formatMessage({ id: 'ADD_MEMBERS_DESCRIPTION', defaultMessage: 'Add members from your workspace to this chat' })}
                  </p>
                </div>
              </button>

              {/* Exit chat row */}
              {!isDirectChat && (
                <button
                  onClick={() => setIsExitModalOpen(true)}
                  className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-left transition-all"
                  style={{ border: '1px solid rgba(239,68,68,0.12)', background: 'rgba(239,68,68,0.03)', cursor: 'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.07)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.03)'}
                >
                  <div className="flex items-center justify-center size-9 rounded-lg flex-shrink-0" style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.18)' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(239,68,68,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                  </div>
                  <div>
                    <p style={{ fontSize: 13.5, fontWeight: 600, color: 'rgba(239,68,68,0.85)', margin: 0 }}>
                      {intl.formatMessage({ id: 'EXIT_CHAT', defaultMessage: 'Exit Chat' })}
                    </p>
                    <p style={{ fontSize: 11.5, color: 'rgba(15,15,25,0.42)', margin: 0 }}>
                      {intl.formatMessage({ id: 'EXIT_CHAT_DESCRIPTION', defaultMessage: 'Remove this chat from your workspace' })}
                    </p>
                  </div>
                </button>
              )}

              {/* Members count row */}
              <div className="flex items-center gap-3 px-3 py-2.5 mt-1" style={{ borderBottom: '1px solid rgba(99,102,241,0.08)' }}>
                <div className="flex items-center justify-center size-9 rounded-lg flex-shrink-0" style={{ background: 'rgba(99,102,241,0.06)', border: '1px solid rgba(99,102,241,0.1)' }}>
                  <span style={{ fontSize: 16, fontWeight: 800, color: '#4f46e5' }}>{displayCount}</span>
                </div>
                <div>
                  <p style={{ fontSize: 13.5, fontWeight: 600, color: 'rgba(15,15,25,0.8)', margin: 0 }}>{displayLabel}</p>
                  <p style={{ fontSize: 11.5, color: 'rgba(15,15,25,0.42)', margin: 0 }}>
                    {showAddMember
                      ? intl.formatMessage({ id: 'SELECT_MEMBERS_TO_ADD', defaultMessage: 'Select individual members to add to chat' })
                      : intl.formatMessage({ id: 'SELECT_MEMBERS_FOR_MORE_DETAILS', defaultMessage: 'Select individual members for more details' })}
                  </p>
                </div>
              </div>

              {/* Add member select */}
              {showAddMember && (
                <div className="flex items-center gap-2 py-3">
                  <button
                    onClick={() => setShowAddMember(false)}
                    className="flex items-center justify-center size-7 rounded-lg flex-shrink-0 transition-all"
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.08)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(15,15,25,0.5)" strokeWidth="2.5" strokeLinecap="round">
                      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                  <Select
                    value={assigneeValue}
                    isMulti
                    isClearable={false}
                    options={allUsers
                      ?.filter((newUser) => !chat?.members?.some((existingUser) => existingUser?._id === newUser?._id))
                      ?.map((participant) => ({
                        value: participant?._id,
                        label: participant?.fullName,
                        email: participant?.email,
                        avi: participant?.avi,
                        role: 'collaborator',
                      }))}
                    formatOptionLabel={AssigneeOptionLabel}
                    onChange={(participants) => setAssigneeValue(participants)}
                    autoFocus={true}
                    placeholder={intl.formatMessage({ id: 'ADD_TO_CHAT', defaultMessage: 'Add to chat...' })}
                    classNames={{
                      menuList: () => 'scroll-y',
                      control: () => 'flex items-center bg-white text-sm font-medium text-slate-800 rounded-lg border border-indigo-300 hover:border-indigo-400 shadow-sm',
                      container: () => 'flex-1',
                    }}
                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                    styles={{ menu: (base) => ({ ...base, width: '100%' }) }}
                  />
                  <button
                    onClick={() => {
                      const userIds = assigneeValue.map((val) => val?.value) || [];
                      dispatch(addUserToChat({ users: userIds, chatId: chat?._id, accessTime: new Date() }));
                      setShowAddMember(false);
                    }}
                    style={{ height: 36, padding: '0 14px', borderRadius: 9, border: 'none', background: '#4f46e5', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', flexShrink: 0, boxShadow: '0 2px 8px rgba(79,70,229,0.28)' }}
                  >
                    <FormattedMessage id="ADD" defaultMessage="Add" />
                  </button>
                </div>
              )}

              {/* Members list */}
              <div className="flex flex-col gap-1 pb-6 mt-1">
                {chatMembers?.map((member, i) => {
                  const actions = [
                    {
                      label: intl.formatMessage({ id: 'MESSAGE', defaultMessage: 'Message' }),
                      icon: '/images/icons/message.svg',
                      description: intl.formatMessage({ id: 'SEND_DM_DETAILS', defaultMessage: 'Send a direct message to {name}' }, { name: member?.fullName }),
                      onClick: () => openChat(member._id),
                    },
                    {
                      label: intl.formatMessage({ id: 'COPY_EMAIL', defaultMessage: 'Copy Email' }),
                      icon: '/images/icons/copy.svg',
                      description: intl.formatMessage({ id: 'COPY_EMAIL_DETAILS', defaultMessage: 'Copy {email} to clipboard' }, { email: member?.email }),
                      onClick: () => {
                        navigator.clipboard.writeText(member.email || '');
                        notification.success({ message: intl.formatMessage({ id: 'EMAIL_COPIED_TO_CLIPBOARD', defaultMessage: 'Email copied to clipboard' }), placement: 'bottomRight' });
                      },
                    },
                    {
                      label: intl.formatMessage({ id: 'REMOVE', defaultMessage: 'Remove' }),
                      icon: '/images/icons/delete-red.svg',
                      description: intl.formatMessage({ id: 'REMOVE_MEMBER_DETAILS', defaultMessage: 'Remove {email} from Chat' }, { email: member?.email }),
                      onClick: () => {
                        dispatch(removeUserFromChat({ chatId: chat._id, users: [member._id] }, () => {
                          const updated = [...chatMembers];
                          updated.splice(i, 1);
                          setChatMembers(updated);
                        }));
                      },
                    },
                  ];

                  const positionStyle =
                    i === chatMembers.length - 1 ? { top: '-140px', right: '20px' }
                    : i === chatMembers.length - 2 ? { top: '-90px', right: '15px' }
                    : i === chatMembers.length - 3 ? { top: '-30px', right: '15px' }
                    : { top: '10px', right: '0' };

                  return (
                    <div
                      key={i + member?._id}
                      className="flex items-center justify-between px-2 py-2 rounded-xl cursor-pointer transition-all"
                      style={{ background: 'transparent' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.04)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <div
                        className="flex items-center gap-3 flex-1 min-w-0"
                        onClick={() => {
                          dispatch(isChatSettingsOpen(false));
                          me?._id === member?._id
                            ? setTimeout(() => dispatch(isUserDrawerOpen(true)), 300)
                            : setTimeout(() => navigate(`/profile/${member?._id}`), 300);
                        }}
                      >
                        <UserAvatar
                          classNames="size-10 rounded-full object-cover flex-shrink-0"
                          fullName={member?.fullName}
                          userId={member?._id}
                          src={member?.avi}
                          styles={{ borderRadius: '50%', objectFit: 'cover' }}
                        />
                        <div className="min-w-0">
                          <p style={{ fontSize: 13.5, fontWeight: 600, color: 'rgba(15,15,25,0.82)', margin: 0 }} className="truncate">{member?.fullName}</p>
                          <p style={{ fontSize: 11.5, color: 'rgba(15,15,25,0.4)', margin: 0 }} className="truncate">{member?.email || ''}</p>
                        </div>
                      </div>
                      <div className="relative inline-block flex-shrink-0" ref={(el) => (menuRefs.current[member._id] = el)}>
                        {!(me?._id === member?._id || isDirectChat) && (
                          <>
                            <button
                              onClick={() => me?._id !== member?._id && toggleMenu(member._id)}
                              className="flex items-center justify-center size-7 rounded-lg transition-all"
                              style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                              onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.1)'}
                              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                            >
                              <img src="/images/icons/threeVerticalDots.svg" alt="" className="size-4" />
                            </button>
                            <MemberActionsMenu
                              isMenuOpen={openMenuMemberId === member._id}
                              closeMenu={() => setOpenMenuMemberId(null)}
                              menuRef={menuRefs.current[member._id]}
                              actions={actions}
                              positionStyle={positionStyle}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    chats: state.chatReducer.chats,
    drawerWidth: state.toggleReducer.drawerWidth,
    allUsers: state?.userReducer?.users,
    currentWorkspace: state.workspaceReducer.currentWorkspace,
  };
}

export default connect(mapStateToProps)(UserChatPanel);
